import { StoreState } from '@/core/store';
import { ActionContext } from 'vuex';
import { CommunicationLanguage } from './communication-language.interface';

import { CommunicationLanguageService } from './communication-language.service';
const service = new CommunicationLanguageService();

export interface CommunicationLangageState {
   communicationLanguages: Array<CommunicationLanguage>;
}

const state: CommunicationLangageState = {
   communicationLanguages: [],
};

const getters = {
   communicationLanguages(state: CommunicationLangageState) {
      return state.communicationLanguages;
   },
};

const mutations = {
   SET_COMMUNICATION_LANGUAGES(state: CommunicationLangageState, communicationLanguages: Array<CommunicationLanguage>) {
      state.communicationLanguages = communicationLanguages;
   },
};

const actions = {
   async getCommunicationLanguages(context: ActionContext<CommunicationLangageState, StoreState>) {
      const communicationLanguages = await service.getCommunicationLanguages();
      context.commit('SET_COMMUNICATION_LANGUAGES', communicationLanguages);
      return communicationLanguages;
   },
};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
};
